export default "__VITE_ASSET__BC0W7j9j__"